import React from "react";
import { styles } from "./leadsStyles";

export function LeadsTabBar({ activeTab, setActiveTab, showGoogleCalendarTab }) {
  return (
          <div style={styles.tabHeader}>
            <button 
              style={{
                ...styles.tabButton,
                ...(activeTab === 'leads' ? styles.tabButtonActive : styles.tabButtonInactive)
              }} 
              onClick={() => setActiveTab('leads')}
            >
              Lista de Leads
            </button>
            <button 
              style={{
                ...styles.tabButton,
                ...(activeTab === 'export' ? styles.tabButtonActive : styles.tabButtonInactive)
              }} 
              onClick={() => setActiveTab('export')}
            >
              Exportar Leads
            </button>
            <button 
              style={{
                ...styles.tabButton,
                ...(activeTab === 'webhook' ? styles.tabButtonActive : styles.tabButtonInactive)
              }} 
              onClick={() => setActiveTab('webhook')}
            >
              Configurar Webhook
            </button>
            <button 
              style={{
                ...styles.tabButton,
                ...(activeTab === 'rdstation' ? styles.tabButtonActive : styles.tabButtonInactive)
              }} 
              onClick={() => setActiveTab('rdstation')}
            >
              RD Station
            </button>
            {showGoogleCalendarTab && (
              <button 
                style={{
                  ...styles.tabButton,
                  ...(activeTab === 'google_calendar' ? styles.tabButtonActive : styles.tabButtonInactive)
                }} 
                onClick={() => setActiveTab('google_calendar')}
              >
                Google Agenda
              </button>
            )}
            <button 
              style={{
                ...styles.tabButton,
                ...(activeTab === 'email' ? styles.tabButtonActive : styles.tabButtonInactive)
              }} 
              onClick={() => setActiveTab('email')}
            >
              Notificações por email
            </button>
          </div>
  );
}
